import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import {Aangever, Aangifte} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-apv-lijst',
  templateUrl: './apv-lijst.component.html',
  styleUrls: ['./apv-lijst.component.scss'],
})
export class ApvLijstComponent implements OnInit, OnDestroy {
  aangifte = <Aangifte>{};
  aangifteChange = new EventEmitter<Aangifte>();

  constructor(private fb: FormBuilder) {}

  saveChanges(): void {
    // this.aangifte.aangever = (<Aangever>this.aangever.getRawValue())
    this.aangifteChange.emit(this.aangifte);
    sessionStorage.setItem('entities', JSON.stringify(this.aangifte));
  }

  public ngOnInit(): void {}

  public ngOnDestroy() {}
}
